import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, ZendeskIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ZendeskIntegrationResponseDataSchema>>

export const zendeskIntegrationQueryKey = ["zendeskIntegration"]

type Props = {
  onSuccess?: (data: Response) => void
}

export const zendeskIntegrationQuery = ({ onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: zendeskIntegrationQueryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/zendesk`)

      onSuccess?.(response.data)

      return response.data.data ?? null
    },
  })
}
